import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { SEARCH_RADIUS } from './constants';

const now = new Date();
const year = now.getFullYear();
const radius = SEARCH_RADIUS;

export default (name) => ({
  name,
  namespaced: true,
  state: () => ({
    toggledMonths: [],
    toggledMonthSessions: [],
    toggledSoldOutSessions: [],
  }),
  actions,
  mutations,
  getters: getters({
    year,
    radius,
  }),
});
